import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";
import { Card, Text } from "@clipboard-health/ui-components";
import { CardContent, Stack } from "@mui/material";
import { generatePath, useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { type WorkerRequirement } from "../../Documents/api/types";
import { DocumentsPageDocumentCards } from "../../Documents/DocumentsPage/DocumentCards";
import { DOCUMENT_DETAILS_FULL_PATH } from "../../Documents/paths";
import { RolesEmptyStateCard } from "../EmptyStateCard";

interface CredentialRequirementContentProps {
  qualificationLabel: string;
  workerBaseCredentialRequirement: WorkerRequirement;
}
export function CredentialRequirementContent(props: CredentialRequirementContentProps) {
  const history = useHistory();
  const { qualificationLabel, workerBaseCredentialRequirement } = props;
  const isUploaded = workerBaseCredentialRequirement.status !== WorkerRequirementStatus.MISSING;

  const onAddCredential = () => {
    history.push(
      generatePath(DOCUMENT_DETAILS_FULL_PATH, {
        requirementId: workerBaseCredentialRequirement.requirementId,
      })
    );
  };

  return (
    <Stack sx={{ padding: 5, flex: 1, overflow: "auto" }} spacing={8}>
      <Text variant="body1" color={(theme) => theme.palette.text.secondary}>
        To interview for {qualificationLabel} jobs or book shifts, you need to upload a valid
        qualification
      </Text>

      {isUploaded ? (
        <Card outlined variant="quaternary" sx={{ flexShrink: 0 }}>
          <CardContent>
            <DocumentsPageDocumentCards documents={[workerBaseCredentialRequirement]} />
          </CardContent>
        </Card>
      ) : (
        <RolesEmptyStateCard title="You haven't added any qualifications yet.">
          <Button fullWidth size="large" variant="contained" onClick={onAddCredential}>
            Add Qualification
          </Button>
        </RolesEmptyStateCard>
      )}
    </Stack>
  );
}
